import INPUT_ID from './inputId';
import DEMO_APP_DETAILS from './demoAppLoginDetails';

export { INPUT_ID, DEMO_APP_DETAILS };
